import { createSlice } from '@reduxjs/toolkit';

const NAME = 'distribution';

const getToday = () => {
    return +new Date();
}

const INITIAL_STATE = {
    month: null,
    year: null,
    today: getToday(),
    data: null,
    partners: null
};

const distributionReducer = createSlice({
    name: NAME,
    initialState: INITIAL_STATE,
    reducers: {
        updateDistribution: (state, action) => {
            return {
                ...state,
                ...action.payload
            }
        },
        resetDistribution: () => {
            return {
                month: null,
                year: null,
                today: +new Date(),
                data: null,
                partners: null
            };;
        }
    }
});

export const { updateDistribution, resetDistribution } = distributionReducer.actions;
export const selectDistribution = (state) => state.distribution;
export default distributionReducer.reducer;
